<template>
  <el-dropdown trigger="click" class='international' @command="handleSetLanguage">
    <div>
      <!-- <svg-icon class-name='international-icon' icon-class="language" />-->
      <span class="el-dropdown-link">
      <!-- {{language==='CN'?"Language":'语言'}}<i class="el-icon-arrow-down el-icon--right"></i> -->
       {{language==='CN'?"CN":'EN'}}<i class="el-icon-caret-bottom el-icon--right" style="font-size:21px;cursor:pinter;"></i>
    </span>
    </div>
    <el-dropdown-menu slot="dropdown">
 <el-dropdown-item command="EN" :disabled="language==='EN'" class="text">English</el-dropdown-item>
      <el-dropdown-item command="CN" :disabled="language==='CN'" class="text">中文</el-dropdown-item>

    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {
    languageRequest
  } from '../request/language'
  export default {
    computed: {
      language() {
        return window.$.cookie('LanguagesTag')
      }
    },
    methods: {
      handleSetLanguage(lang) {
        window.$.cookie('LanguagesTag', lang)
        localStorage.setItem('LanguagesTag', lang)
        languageRequest.Change(function(d) {
          window.location.reload()
        }, this.language)
      }
    }
  }
</script>

<style scoped>
  .international-icon {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -5px!important;
  }
  .el-dropdown-menu__item{
    font-size: 15px;
    font-family: Helvetica;
  }
</style>




// WEBPACK FOOTER //
// LangSelect.vue?e5e92d7c